import { Injectable } from '@angular/core';
import {
  Action,
  State,
  StateContext,
  createPropertySelectors,
} from '@ngxs/store';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace FieldWeatherStation {
  const type = 'FieldWeatherStationState';

  export class SetTemperatureAverage {
    static readonly type = `[${type}] SetTemperatureAverage`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetTemperatureMin {
    static readonly type = `[${type}] SetTemperatureMin`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetTemperatureMax {
    static readonly type = `[${type}] SetTemperatureMax`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetTemperatureGDD {
    static readonly type = `[${type}] SetTemperatureGDD`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetHumidityMin {
    static readonly type = `[${type}] SetHumidityMin`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetHumidityMax {
    static readonly type = `[${type}] SetHumidityMax`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetPrecipitationTotal {
    static readonly type = `[${type}] SetPrecipitationTotal`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetEt0Total {
    static readonly type = `[${type}] SetEt0Total`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetWindAverage {
    static readonly type = `[${type}] SetWindAverage`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetWindMax {
    static readonly type = `[${type}] SetWindMax`;

    constructor(public value: number | null | undefined) {}
  }

  export class SetRadiationTotal {
    static readonly type = `[${type}] SetRadiationTotal`;

    constructor(public value: number | null | undefined) {}
  }
}

export interface FieldWeatherStationStateModel {
  temperatureAvg: number | null | undefined;
  temperatureMin: number | null | undefined;
  temperatureMax: number | null | undefined;
  temperatureGDD: number | null | undefined;
  humidityMin: number | null | undefined;
  humidityMax: number | null | undefined;
  precipitationTotal: number | null | undefined;
  et0Total: number | null | undefined;
  windAvg: number | null | undefined;
  windMax: number | null | undefined;
  radiationTotal: number | null | undefined;
}

@State<FieldWeatherStationStateModel>({
  name: 'fieldWeatherStation',
  defaults: {
    temperatureAvg: undefined,
    temperatureMin: undefined,
    temperatureMax: undefined,
    temperatureGDD: undefined,
    humidityMin: undefined,
    humidityMax: undefined,
    precipitationTotal: undefined,
    et0Total: undefined,
    windAvg: undefined,
    windMax: undefined,
    radiationTotal: undefined,
  },
})
@Injectable()
export class FieldWeatherStationState {
  @Action(FieldWeatherStation.SetTemperatureMin)
  setTemperatureMin(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetTemperatureMin,
  ): void {
    ctx.patchState({
      temperatureMin: action.value,
    });
  }

  @Action(FieldWeatherStation.SetTemperatureMax)
  setTemperatureMax(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetTemperatureMax,
  ): void {
    ctx.patchState({
      temperatureMax: action.value,
    });
  }

  @Action(FieldWeatherStation.SetTemperatureAverage)
  setTemperatureAverage(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetTemperatureAverage,
  ): void {
    ctx.patchState({
      temperatureAvg: action.value,
    });
  }

  @Action(FieldWeatherStation.SetTemperatureGDD)
  setTemperatureGDD(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetTemperatureGDD,
  ): void {
    ctx.patchState({
      temperatureGDD: action.value,
    });
  }

  @Action(FieldWeatherStation.SetHumidityMin)
  setHumidityMin(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetHumidityMin,
  ): void {
    ctx.patchState({
      humidityMin: action.value,
    });
  }

  @Action(FieldWeatherStation.SetHumidityMax)
  SetHumidityMax(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetHumidityMax,
  ): void {
    ctx.patchState({
      humidityMax: action.value,
    });
  }

  @Action(FieldWeatherStation.SetPrecipitationTotal)
  setPrecipitationTotal(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetPrecipitationTotal,
  ): void {
    ctx.patchState({
      precipitationTotal: action.value,
    });
  }

  @Action(FieldWeatherStation.SetEt0Total)
  setEt0Total(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetEt0Total,
  ): void {
    ctx.patchState({
      et0Total: action.value,
    });
  }

  @Action(FieldWeatherStation.SetWindAverage)
  setWindAverage(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetWindAverage,
  ): void {
    ctx.patchState({
      windAvg: action.value,
    });
  }

  @Action(FieldWeatherStation.SetWindMax)
  setWindMax(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetWindMax,
  ): void {
    ctx.patchState({
      windMax: action.value,
    });
  }

  @Action(FieldWeatherStation.SetRadiationTotal)
  setRadiationTotal(
    ctx: StateContext<FieldWeatherStationStateModel>,
    action: FieldWeatherStation.SetRadiationTotal,
  ): void {
    ctx.patchState({
      radiationTotal: action.value,
    });
  }
}

export class FieldWeatherStationSelectors {
  static slices = createPropertySelectors<FieldWeatherStationStateModel>(
    FieldWeatherStationState,
  );
}
